require('./sidebar/modules.module');
require('./logo/logo.component');
require('./chart/chartDirectives');
require('./chart/chart.component');

angular
    .module('commonModules', [
        'sidebar.module',
    ]);